export type UserRole = 'owner' | 'manager' | 'staff';

export interface Profile {
  id: string;
  email: string;
  full_name: string | null;
  role: UserRole;
  is_active: boolean;
  avatar_url?: string | null;
  created_at: string;
  updated_at: string;
}

export interface ShopSettings {
  id: string;
  shop_name: string;
  phone: string | null;
  email: string | null;
  address: string | null;
  currency: string;
  currency_symbol: string;
  timezone: string;
  terms_conditions: string | null;
  created_at: string;
  updated_at: string;
}

// Module Permissions map
export type PermissionModule =
  | 'dashboard'
  | 'laptops'
  | 'accessories'
  | 'purchases'
  | 'sales'
  | 'returns'
  | 'customers'
  | 'suppliers'
  | 'repairs'
  | 'warranties'
  | 'expenses'
  | 'reports'
  | 'audit'
  | 'settings'
  | 'scanner';

export interface RolePermissions {
  canViewCosts: boolean;
  canViewProfit: boolean;
  canViewSuppliers: boolean;
  canViewExpenses: boolean;
  canViewAuditLog: boolean;
  canManageUsers: boolean;
  canManageSettings: boolean;
  canApplyDiscounts: boolean;
  canImportPurchaseSpreadsheet: boolean;
  allowedModules: PermissionModule[];
}

export const ROLE_PERMISSIONS: Record<UserRole, RolePermissions> = {
  owner: {
    canViewCosts: true,
    canViewProfit: true,
    canViewSuppliers: true,
    canViewExpenses: true,
    canViewAuditLog: true,
    canManageUsers: true,
    canManageSettings: true,
    canApplyDiscounts: true,
    canImportPurchaseSpreadsheet: true,
    allowedModules: [
      'dashboard',
      'laptops',
      'accessories',
      'purchases',
      'sales',
      'returns',
      'customers',
      'suppliers',
      'repairs',
      'warranties',
      'expenses',
      'reports',
      'audit',
      'settings',
      'scanner',
    ],
  },
  manager: {
    canViewCosts: true,
    canViewProfit: true,
    canViewSuppliers: true,
    canViewExpenses: true,
    canViewAuditLog: false,
    canManageUsers: false,
    canManageSettings: false,
    canApplyDiscounts: true,
    canImportPurchaseSpreadsheet: false,
    allowedModules: [
      'dashboard',
      'laptops',
      'accessories',
      'purchases',
      'sales',
      'returns',
      'customers',
      'suppliers',
      'repairs',
      'warranties',
      'expenses',
      'reports',
      'scanner',
    ],
  },
  staff: {
    canViewCosts: false,
    canViewProfit: false,
    canViewSuppliers: false,
    canViewExpenses: false,
    canViewAuditLog: false,
    canManageUsers: false,
    canManageSettings: false,
    canApplyDiscounts: false,
    canImportPurchaseSpreadsheet: false,
    allowedModules: [
      'dashboard',
      'laptops',
      'accessories',
      'sales',
      'customers',
      'repairs',
      'warranties',
      'scanner',
    ],
  },
};
